/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AssingTermAliases {
  CHECKBOX = 'checkbox',
  FETCH_0 = 'fetch-0',
  FIELD_1 = 'field-1',
  FIELD_CHECKBOX = 'field-checkbox',
  FIELD_NR_SEQ = 'field-nrSeq',
  FIELD_TYPE = 'field-type',
  FORM_TERM = 'form-term',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  PANEL_0 = 'panel-0',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AssingTermAliases };
